var render = function render(){var _vm=this,_c=_vm._self._c;return _c('SAISelect',_vm._g(_vm._b({staticClass:"full-width",attrs:{"options":_vm.leases,"option-value":"id","option-label":"vehicleRego","placeholder":"Select","value":_vm.lease.id ? _vm.lease : undefined,"disable":_vm.leases.length === 1 || _vm.disable}},'SAISelect',_vm.$attrs,false),_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }